<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{ name: string; size?: number }>(), { size: 32 });

const initials = computed(() => {
  const parts = props.name.split(' ').filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
});

// Hash name → consistent hue (0..360)
const hue = computed(() => {
  let h = 0;
  for (const ch of props.name) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return h;
});

const styles = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  fontSize: `${Math.max(11, props.size * 0.4)}px`,
  background: `linear-gradient(135deg, hsl(${hue.value} 60% 55%), hsl(${(hue.value + 40) % 360} 60% 45%))`,
}));
</script>

<template>
  <div
    class="inline-flex items-center justify-center rounded-full font-bold text-white shrink-0"
    :style="styles"
    :title="name"
    :aria-label="name"
  >
    {{ initials }}
  </div>
</template>
